import { ApiGenericResponse } from "../ApiGenericResponse";
import { AxiosResponse } from "axios";

export class GetErrorDetailsResData extends ApiGenericResponse {
    codeLabel: string;
    areaLabel: string;
    caosErrorLabel: string;

    constructor(response: AxiosResponse) {
        super(response);
        this.codeLabel = "";
        this.areaLabel = "";
		this.caosErrorLabel = "";
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.CodeLabel) this.codeLabel = obj.CodeLabel;
        if (obj.AreaLabel) this.areaLabel = obj.AreaLabel;
        if (obj.CaosErrorLabel) this.caosErrorLabel = obj.CaosErrorLabel;
    }
}
